import React__default from 'react';

function CommaIcon() {
    return (React__default.createElement("svg", { width: "28", height: "57", viewBox: "0 0 38 67", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M37.0977 66.3083L0.200182 66.1274L0.379195 29.6079L15.3187 0.420736L33.7118 0.510897L18.8465 29.6984L37.2767 29.7887L37.0977 66.3083Z", fill: "black" })));
}

export { CommaIcon as default };
//# sourceMappingURL=comma.icon.js.map
